import { render } from "./GameScoreAndTimeBoard.vue?vue&type=template&id=1cf023bc&scoped=true"
import script from "./GameScoreAndTimeBoard.vue?vue&type=script&lang=js"
export * from "./GameScoreAndTimeBoard.vue?vue&type=script&lang=js"

import "./GameScoreAndTimeBoard.vue?vue&type=style&index=0&id=1cf023bc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf023bc"]])

export default __exports__